module.exports = __webpack_public_path__ + "media/images/how_it_works/step-6-01858c3dd2a4d4136b102f6c1c0e9f17.svg";